import React, {useEffect} from "react";
import { Outlet } from "react-router-dom";
import useAppUrl from "../../../hooks/useAppUrl";
import { MainContainer, ContentContainer } from "./Layout.style";

const NewsletterLayout = () => {
  const { appPath, setAppPath, appName, setAppName } = useAppUrl();
  useEffect(() => {
    setAppName("Newsletter");
    setAppPath("/newsletter");
  }, [])
  
  return (
    <>
      <MainContainer>
          <Outlet />
      </MainContainer>
    </>
  );
};

export default NewsletterLayout;
